import { useEffect } from "react";

// react-router-dom components
import { useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React context
import { useAuth } from "context";

function DashboardLayout({ children, fullWidth }) {
  const { setLayout, miniSidenav } = useAuth();
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout("dashboard");
  }, [pathname]);

  return (
    <MDBox
      sx={({ breakpoints, transitions, functions: { pxToRem } }) => {
        let marginLeft;
        if (fullWidth) {
          marginLeft = 0;
        } else if (miniSidenav) {
          marginLeft = pxToRem(120);
        } else {
          marginLeft = pxToRem(220);
        }
        return {
          px: 2.5,
          py: 1.5,
          position: "relative",

          [breakpoints.up("lg")]: {
            marginLeft: marginLeft,
            transition: transitions.create(["margin-left", "margin-right"], {
              easing: transitions.easing.easeInOut,
              duration: transitions.duration.standard,
            }),
          },
        };
      }}
    >
      {children}
    </MDBox>
  );
}

// Typechecking props for the DashboardLayout
DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
  fullWidth: PropTypes.bool,
};

export default DashboardLayout;
